
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getVentilation } from "../../store/ventilationPage/VentilitaionPageFetch";
import useOrderValidate from "./orderValidate";
import style from "./style.module.css";
import lang from "lang/lang";
import axios from "axios";

const VentilationForm = ({ openModal, setOpenModal }) => {

    const dispatch = useDispatch();
    const { currentLanguage } = useSelector(({main}) => main);
    const { ventilationInfo } = useSelector((state) => state.ventilationPageSlice);
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(false);

    useEffect(() => {
        dispatch(getVentilation());
    }, [dispatch]);

    const {
        validation,
        personInfo,
        errorText,
        setPersonInfo,
        setErrorText
    } = useOrderValidate();

    const handleChange = (e) => {
        setPersonInfo({...personInfo, [e.target.name]: e.target.value});
        setErrorText({...errorText, [e.target.name]: ""});
    };

    const postData = async () => {
        setLoading(true);
        try {
            const _token = document.querySelector('meta[name="_token"]').content;
            const response = await axios.post(
                process.env.REACT_APP_SERVER_URL + "api/air-conditioning-order/send",
                    {
                        ...personInfo,
                        login: "VlvShopA",
                        password: "oL0rG6vQ6k",
                        token:"quHRhfW9R7SbNFUCEBEBmzCRbIa5Z3"
                    },
                {
                    headers: {
                        "Content-Type": "application/json",
                        "X-CSRF-Token": _token,
                    },
                }
            );
            console.log(response);

            if (response) {
                setSuccess(true);
            }
        }
        catch (error) {
            console.log(error);
            setError(true);
        }
        finally {
            setLoading(false);
        }
    };

    const handleClick = async (e) => {
        e.preventDefault();
        if (validation()) {
            await postData();
        }
    };

    const closeModal = () => {
        setPersonInfo({
            name: '',
            surname:'',
            email:'',
            phone:'',
            profession:'',
            brand: '',
            messageText:''
        })
        setErrorText({
            name: '',
            email: '',
            brand: '',
            profession: ''
        })
        setSuccess(false);
        setError(false);
        setOpenModal(false);
    }

    return (
        <div className={style.container}>
            <div className={style.bannerConatiner}>
                <img
                    src={ process.env.REACT_APP_STORAGE_URL + ventilationInfo?.setting?.banner}
                    alt = { 'banner' }
                />
            </div>
            <form className={style.order_form} onSubmit={postData}>
                <span>{lang[currentLanguage].order}</span>
                <div className={style.add_personal_inputs}>
                    <div className={style.add_personal_inputs}>
                        <input
                            type="text"
                            value={personInfo.name}
                            name={"name"}
                            onChange={handleChange}
                            className={` ${errorText.name && style.inputError}`}
                            placeholder={lang[currentLanguage].name + " *"}
                        />
                    </div>
                    <div className={style.order_inputs_name}>
                        <input
                            type="text"
                            name={"surname"}
                            value={personInfo.lastName}
                            onChange={handleChange}
                            placeholder={lang[currentLanguage].last_name}
                        />
                    </div>
                </div>
                <div className={style.add_personal_inputs}>
                    <input
                        type="text"
                        name={"email"}
                        value={personInfo.email}
                        onChange={handleChange}
                        className={` ${errorText.email && style.inputError}`}
                        placeholder={lang[currentLanguage].email + " *"}
                    />
                </div>
                <div className={style.add_personal_inputs}>
                    <input
                        type="number"
                        value={personInfo.phone}
                        name={"phone"}
                        onChange={handleChange}
                        className={` ${errorText.phone && style.inputError}`}
                        placeholder={"Բջջային հեռ. " + " *"}
                    />
                </div>
                <div className={style.add_personal_inputs}>
                    <input
                        type="text"
                        name={"brand"}
                        value={personInfo.brand}
                        onChange={handleChange}
                        className={` ${errorText.brand && style.inputError}`}
                        placeholder={lang[currentLanguage].brand + " *"}
                    />
                </div>
                <div className={style.add_personal_inputs}>
                    <input
                        type="text"
                        name={"profession"}
                        value={personInfo.profession}
                        onChange={handleChange}
                        className={` ${errorText.profession && style.inputError}`}
                        placeholder={lang[currentLanguage].Category + " *"}
                    />
                </div>
                <div className={style.add_personal_inputs}>
                    <textarea
                        value={personInfo.messageText}
                        onChange={handleChange}
                        name="messageText"
                        className={style.textarea_comment_order}
                        cols="30"
                        rows="5"
                        placeholder={lang[currentLanguage].comment_order}
                    />
                </div>
                {
                    error &&
                        <span
                            style = {{
                                color: "red",
                                fontSize: "0.8rem",
                                textAlign: 'center'
                            }}
                        >
                            {lang[currentLanguage].error_message}
                        </span>
                }
                {
                    success &&
                        <span
                            style = {{
                                color: "green",
                                fontSize: "0.8rem",
                                textAlign: 'center'
                            }}
                        >
                            {lang[currentLanguage].approved_successfully}
                        </span>
                }
                <button
                    onClick = { handleClick }
                    className = { style.order_submit }
                    type="submit"
                    disabled={loading}
                    style={{
                        opacity: loading ? 0.3 : 1 ,
                    }}
                >
                    {lang[currentLanguage].order_state + " *"}
                </button>
            </form>
            {/*<p*/}
            {/*    style={{*/}
            {/*        width: "100%",*/}
            {/*        textAlign: "center"*/}
            {/*    }}*/}
            {/*>*/}
            {/*    { ventilationInfo?.setting?.['text_' + currentLanguage] }*/}
            {/*</p>*/}
        </div>
    )
};

export default VentilationForm;
